// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import { splitProps, type JSX } from "solid-js";
import { useRouter } from "@tanstack/solid-router";

export function useGo() {
  const router = useRouter();
  return (to: string, replace = false) => router.navigate({ to, replace });
}

type AppLinkProps = Omit<
  JSX.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href" | "onClick"
> & {
  to: string;
  onNavigate?: () => void;
};

export function AppLink(p: AppLinkProps) {
  const go = useGo();
  const [local, anchor] = splitProps(p, ["to", "onNavigate"]);
  return (
    <a
      {...anchor}
      data-spa-navigation
      href={local.to}
      onClick={(event) => {
        if (
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        )
          return;
        event.preventDefault();
        local.onNavigate?.();
        go(local.to);
      }}
    />
  );
}
